export default __webpack_public_path__ + "static/media/kop_surat.297c79a2.png";